<template>
	<div class="stage-child-status-wrapper">
		<div class="stage-child-status">
			<slot />
		</div>
		<div class="stage-card-expand-collapse-icon">
			<Icon name="chevron" size="small" :rotate="open ? 180 : 0" @click="handleClick($event)" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "StageChildStatus",
	components: {
		Icon
	},
	props: {
		/**
		 * true | false <br/> To show open or close icon
		 */
		open: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event.
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
$disabled-color: var(--dashboard-font-light);

$status-colors: (
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"inProgress": var(--dashboard-primary),
	"warning": var(--dashboard-warning),
	"standby": $disabled-color,
	"paused": $disabled-color
);
.stage-child-status-wrapper {
	position: relative;
	> .stage-child-status {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(16px, 1fr));
		margin-top: -2px;
		grid-gap: 8px;
		align-items: center;

		> * {
			width: 20px;
			height: 20px;
			border-radius: 3px;
			@each $type, $color in $status-colors {
				&[type="#{$type}"] {
					background-color: $color;
				}
			}
		}
	}
	> .stage-card-expand-collapse-icon {
		position: absolute;
		left: calc(50% - 7px);
		top: calc(100% + 7px);
		> div.icon-container {
			> .icon {
				z-index: 1;
			}
			&:after {
				content: "";
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				position: absolute;
				border-radius: 50%;
				outline: none;
				transform: scale(1.5);
				transform-origin: center;
				background-color: var(--dashboard-border);
			}
		}
	}
}
</style>
